import styled from 'styled-components'

import { type Size } from '@blade/ui-kit'
import { Dialog } from '@root/shared/ui-kit'

type SettingsModalContentProps = {
  header: React.ReactNode
  children: React.ReactNode
  size?: Extract<Size, 's' | 'm'>
}

export const SettingsModalContent: React.FC<SettingsModalContentProps> = ({
  header,
  children,
  size = 's',
}) => (
  <Body data-size={size}>
    {header}
    <Dialog.Content.Functional $variant={0}>
      <Dialog.Content.Functional $variant={1}>
        {children}
      </Dialog.Content.Functional>
    </Dialog.Content.Functional>
  </Body>
)

const Body = styled.div`
  width: 600px;

  &[data-size='m'] {
    width: 900px;
    height: 600px;
  }

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
